// hooks/useEntitySidebar.ts
import { ContactModelBase } from 'Models/ContactModel';
import { ContactModelV2 } from 'Models/ContactModelV2';
import { useUIStore } from 'Modules/ui/index.store';
import { useCallback, useMemo, useState } from 'react';

type SidebarType = 'oneOnOne' | 'group' | 'contact';

/**
 * Hook to handle the entity sidebar.
 * @returns The sidebar state, close panel function, and z-index
 * @returns The sidebar state, close panel function, and z-index
 */
export const useEntitySidebar = () => {
  const { entitySidePanelInfo, resetEntitySidePanel } = useUIStore();

  const [contact, setContact] = useState<
    ContactModelV2 | ContactModelBase | null
  >(null);
  const [navigatedContacts, setNavigatedContacts] = useState<
    (ContactModelV2 | ContactModelBase)[]
  >([]);

  const sidebarToShow = useMemo<SidebarType | null>(() => {
    if (entitySidePanelInfo?.entityId) {
      return 'oneOnOne';
    } else if (entitySidePanelInfo?.groupConversationId) {
      return 'group';
    } else if (entitySidePanelInfo?.contact) {
      setContact(entitySidePanelInfo.contact);
      return 'contact';
    } else {
      return null;
    }
  }, [entitySidePanelInfo]);

  const closePanel = useCallback(() => {
    setNavigatedContacts([]);
    resetEntitySidePanel();
  }, [resetEntitySidePanel]);

  return {
    contact,
    navigatedContacts,
    sidebarToShow,
    closePanel,
    setNavigatedContacts,
  };
};
